module.exports = __webpack_public_path__ + "img/product_11.18d0cf8.jpg";